import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const BookProcess = () => (
  <div className="BookProcess">
    <Container>
      <Row>
        <Col>
          <h2 className="SectionHeading">How it works</h2>
          <p className="BookProcess-SubHeading">
            We makes it easy to book our services. <br className="d-none d-md-block" />
            Try any modern web browser or download the app, and you're ready to go.
          </p>
          <Row className="BookProcess-Step__Line">
            <Col md={4}>
              <div className="BookProcess-Step">
                <span className="BookProcess-Step__Number">1</span>
                <h5 className="text-dark">Choose the service</h5>
                <p className="text-secondary mb-0">Click "Book Online" button to choose the service which you need.</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="BookProcess-Step">
                <span className="BookProcess-Step__Number">2</span>
                <h5 className="text-dark">Pick your schedule</h5>
                <p className="text-secondary mb-0">Pick your suitable date and time, our technician will be there on time.</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="BookProcess-Step">
                <span className="BookProcess-Step__Number">3</span>
                <h5 className="text-dark">Place order &amp; relax</h5>
                <p className="text-secondary mb-0">Now place your order and relax. We will assign an expart for you.</p>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  </div>
);

export default BookProcess;